export { default, meta } from "/Users/danhey/github/rabbits/app/root.tsx";